import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DonorsDto } from './donor.dto';


export class AllDonorsResponseModel extends GlobalResponseObject {
    data?: DonorsDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: DonorsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

